import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Dots } from 'react-activity';
import classnames from 'classnames';
import moment from 'moment';
import Icon from '@mdi/react';
import Skeleton from 'react-loading-skeleton';
import {
  Card,
  CardBody,
  Row,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Col,
} from 'reactstrap';
import { mdiDownloadOutline, mdiPhone } from '@mdi/js';

import { setRUTFormat } from '../../../../shared/utils';
import { BATCH_API } from '../../../../helper/constants';

const CaseCustomerDocumentsTabs = ({
  contact,
  cargandoContract,
  edad,
  isAuditor,
  onClickContactoEditar,
  onOpenMakeCall,
  signedDoc,
  onSavePDF,
  allS3Docs,
  getAllS3Documents,
  caseId,
  docS3Loading,
  onSaveDocS3,
  contracts,
}) => {
  const [activeTab, setActiveTab] = useState('1');

  const handleTabChange = (tab) => {
    if (tab === '2' && caseId) {
      getAllS3Documents(caseId);
    }
    setActiveTab(tab);
  };

  return (
    <Card style={{ height: '50%' }}>
      <CardBody style={{ padding: '0px' }}>
        <div className="tabs tabs--bordered-bottom" style={{ overflowX: 'hidden', height: '100%' }}>
          <div className="tabs__wrap">
            <Nav tabs className="w_o_border">
              <NavItem style={{ width: '50%' }}>
                <NavLink
                  style={{ width: 'auto' }}
                  className={`detail_info_customer ${classnames({ active: activeTab === '1' })}`}
                  onClick={() => handleTabChange('1')}
                >
                  Datos cliente
                </NavLink>
              </NavItem>
              <NavItem style={{ width: '50%' }}>
                <NavLink
                  style={{ width: 'auto' }}
                  className={`products_documents ${classnames({ active: activeTab === '2' })}`}
                  onClick={() => handleTabChange('2')}
                >
                  Productos y documentos
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <div className="crm-lateral-personal-data">
                  {contact && (
                    <Fragment>
                      <Row className="ml-3 mb-2">
                        <Col>
                          <Row>
                            <span className="datos-personales mr-3">Datos Personales</span>
                            {!isAuditor && (
                              <Button
                                className="asignar button_details button_profile_detail"
                                id="added"
                                onClick={onClickContactoEditar}
                              >
                                Editar
                              </Button>
                            )}
                          </Row>
                        </Col>
                      </Row>
                      <Row className="ml-3 mb-2">
                        <Col md={6}>
                          <div>
                            <span className="span-title">RUT</span>
                            <br />
                            <span>{contact ? setRUTFormat(contact.rut) : '-'}</span>
                          </div>
                          <div>
                            <span className="span-title">Telefonos</span>
                            <br />
                            <span>
                              {contact?.phones?.length > 0
                                ? map(contact.phones, (phone) => (
                                  <button className="phone-link" key={`${phone.code}${phone.number}`} onClick={() => onOpenMakeCall(phone)}>
                                    <Icon path={mdiPhone} size={0.65} />
                                    {`${phone.code} - ${phone.number}`}
                                    <br />
                                  </button>
                                )) : '-'}
                            </span>
                          </div>
                          <div>
                            <span className="span-title">Region</span>
                            <br />
                            {contact?.addresses?.length > 0
                              ? map(contact.addresses, (address, index) => (
                                <div key={`region-${index}`}>
                                  <span>{`${index + 1}.- ${address?.region?.label || ''}`}</span>
                                </div>
                              ))
                              : '-'}
                          </div>
                          <div>
                            <span className="span-title">Comuna</span>
                            <br />
                            <span>
                              {contact?.addresses?.length > 0
                                ? map(contact.addresses, (address, index) => (
                                  <div key={`commune-${index}`}>
                                    <span>{`${index + 1}.- ${address?.commune?.label || ''}`}</span>
                                  </div>
                                ))
                                : '-'}
                            </span>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div>
                            <span className="span-title">Fecha de Nacimiento</span>
                            <br />
                            <span>{contact?.birthdate ? <span>{moment(contact.birthdate).format('DD/MM/YYYY')}</span> : '-'}</span>
                          </div>
                          <div>
                            <span className="span-title">Email</span>
                            <br />
                            <span>
                              {contact?.emails?.length > 0
                                ? map(contact.emails, (email) => (
                                  <div key={email.email}>
                                    <span>{email.email}</span>
                                    <br />
                                  </div>
                                ))
                                : '-'}
                            </span>
                          </div>
                          <div>
                            <span className="span-title">Renta</span>
                            <br />
                            <span>{contact?.rent || '0'}</span>
                          </div>
                          <div>
                            <span className="span-title">Edad</span>
                            <br />
                            <span>{contact?.birthdate ? <span>{edad}</span> : '-'}</span>
                          </div>
                        </Col>
                        <Col>
                          <div>
                            <span className="span-title">Direccion</span>
                            <br />
                            <span>
                              {contact?.addresses?.length > 0
                                ? map(contact.addresses, (address, index) => (
                                  <div key={`street-${index}`}>
                                    <span>{`${index + 1}.- ${address?.street ? address.street : 'ninguna'}`}</span>
                                  </div>
                                ))
                                : '-'}
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </Fragment>
                  )}
                  {!contact && cargandoContract ? (
                    <Row className="ml-3 mb-2">
                      <Col>
                        <Skeleton count={4} height={40} />
                      </Col>
                      <Col>
                        <Skeleton count={4} height={40} />
                      </Col>
                      <Col>
                        <Skeleton count={1} height={40} />
                      </Col>
                    </Row>
                  ) : (!contact && <div>Sin otro tipo de documento</div>)}
                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="crm-lateral-personal-data">
                  {signedDoc && (
                    <div className="crm-s3-docs">
                      <span className="crm-doc-title">Documento Firmado</span>
                      <Col className="ml-4 mb-4 crm-col">
                        <div>
                          <button
                            title="Descargar"
                            style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                            onClick={onSavePDF}
                            target="_blank"
                          >
                            <Icon path={mdiDownloadOutline} size="15px" />
                            Documento Autofin Portabilidad
                          </button>
                        </div>
                      </Col>
                    </div>
                  )}
                  {allS3Docs?.data?.length ? (
                    <div className="crm-s3-docs">
                      <div className="crm-title-container">
                        <span className="crm-doc-title">Documento Adjunto</span>
                        <button
                          type="button"
                          className="cmr-refresh-btn"
                          onClick={() => getAllS3Documents(caseId)}
                          disabled={allS3Docs.loading}
                        >
                          {allS3Docs.loading ? <Dots /> : 'Actualizar'}
                        </button>
                      </div>
                      <Col className="ml-4 mb-4 crm-col">
                        {map(allS3Docs.data, (doc) => (
                          <div key={doc.name}>
                            <button
                              title="Ir al documento"
                              style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                              onClick={() => onSaveDocS3(doc)}
                              target="_blank"
                              disabled={docS3Loading}
                            >
                              <Icon path={mdiDownloadOutline} size="15px" />
                              {doc.name}
                            </button>
                          </div>
                        ))}
                      </Col>
                    </div>
                  ) : null}
                  {contracts?.length > 0
                    ? map(contracts, (contract) => (
                      <div key={contract?.Id || contract?.NombreProducto}>
                        <Row className="case-rectangle">
                          <Col className="ml-4" sm={4} xs={4} md={4}>
                            <div>
                              <span className="span-title">Producto</span>
                            </div>
                            <div>
                              {contract?.NombreProducto ? <span>{contract.NombreProducto.toUpperCase()}</span> : '-'}
                            </div>
                          </Col>
                          <Col sm={2} xs={2} md={2}>
                            <div>
                              <span className="span-title">ID</span>
                            </div>
                            <div>
                              {contract?.Id ? <span>{`#${contract.Id}`}</span> : '-'}
                            </div>
                          </Col>
                          <Col sm={5} xs={5} md={5}>
                            <Row>
                              <Col>
                                <div>
                                  <span className="span-title">Vehiculo</span>
                                </div>
                                <div>
                                  {contract?.Modelo ? <span>{contract.Modelo}</span> : '-'}
                                </div>
                              </Col>
                              <Col>
                                <div>
                                  <span className="span-title">Marca</span>
                                </div>
                                <div>
                                  {contract?.Marca ? <span>{contract.Marca}</span> : '-'}
                                </div>
                              </Col>
                              <Col>
                                <div>
                                  <span className="span-title">Ano</span>
                                </div>
                                <div>
                                  {contract?.AnnoVehiculo ? <span>{contract.AnnoVehiculo}</span> : '-'}</div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="ml-4">
                            - Certificado Tabla Desarrollo<a
                              className="button-icon-light small"
                              title="Descargar"
                              style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                              href={`${BATCH_API}/aprcImprimirCertTablaDesarrolloPDFCRM.aspx?${contract ? contract.Id : ''}`}
                              target="_blank"
                              download
                            >
                              <Icon path={mdiDownloadOutline} size="15px" />
                            </a>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="ml-4">
                            - Informe de Cuotas<a
                              className="button-icon-light small"
                              title="Descargar"
                              style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                              href={`${BATCH_API}/aprcImprimirInformeCuotasPDFCRM.aspx?${contract ? contract.Id : ''}`}
                              target="_blank"
                              download
                            >
                              <Icon path={mdiDownloadOutline} size="15px" />
                            </a>
                          </Col>
                        </Row>
                        <Row style={{ borderBottom: '1px solid #E5E5E6' }}>
                          <Col className="ml-4">
                            - Copia Contrato<a
                              className="button-icon-light small"
                              title="Descargar"
                              style={{ marginLeft: '10px', display: 'inline-block', lineHeight: '1' }}
                              href={`${BATCH_API}/aContratoAutoWSCRM.aspx?${contract ? contract.Id : ''}`}
                              target="_blank"
                              download
                            >
                              <Icon path={mdiDownloadOutline} size="15px" />
                            </a>
                          </Col>
                        </Row>
                      </div>
                    ))
                    : <Col>Sin otro tipo de documento</Col>}
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

const contactShape = PropTypes.shape({
  rut: PropTypes.string,
  birthdate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  rent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  phones: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  emails: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string,
  })),
  addresses: PropTypes.arrayOf(PropTypes.shape({
    street: PropTypes.string,
    region: PropTypes.shape({ label: PropTypes.string }),
    commune: PropTypes.shape({ label: PropTypes.string }),
  })),
});

const documentShape = PropTypes.shape({
  name: PropTypes.string,
});

CaseCustomerDocumentsTabs.propTypes = {
  contact: contactShape,
  cargandoContract: PropTypes.bool,
  edad: PropTypes.number,
  isAuditor: PropTypes.bool.isRequired,
  onClickContactoEditar: PropTypes.func.isRequired,
  onOpenMakeCall: PropTypes.func.isRequired,
  signedDoc: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onSavePDF: PropTypes.func.isRequired,
  allS3Docs: PropTypes.shape({
    data: PropTypes.arrayOf(documentShape),
    loading: PropTypes.bool,
  }),
  getAllS3Documents: PropTypes.func.isRequired,
  caseId: PropTypes.string,
  docS3Loading: PropTypes.bool,
  onSaveDocS3: PropTypes.func.isRequired,
  contracts: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    NombreProducto: PropTypes.string,
    Modelo: PropTypes.string,
    Marca: PropTypes.string,
    AnnoVehiculo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
};

CaseCustomerDocumentsTabs.defaultProps = {
  contact: null,
  cargandoContract: false,
  edad: 0,
  signedDoc: undefined,
  allS3Docs: { data: [], loading: false },
  caseId: '',
  docS3Loading: false,
  contracts: [],
};

export default CaseCustomerDocumentsTabs;
